import axios from "./_axios";
import { API } from "./apiEndPoints";

const bookBaseUrl = (accountId) => `${API.COMMON_V1}account/${accountId}/book/`;
const bookDetailUrl = (accountId, bookId) => `${bookBaseUrl(accountId)}${bookId}/`;
const bookRenameUrl = (accountId, bookId) => `${bookDetailUrl(accountId, bookId)}rename/`;
const bookChaptersUrl = (accountId, bookId) => `${bookDetailUrl(accountId, bookId)}chapters/`;
const bookCreateChapterUrl = (accountId, bookId) =>
  `${bookDetailUrl(accountId, bookId)}create-chapter/`;

export const createBook = (accountId, payload) =>
  axios()({
    method: "post",
    url: bookBaseUrl(accountId),
    data: payload,
  });

export const getBooks = (accountId, params = undefined) =>
  axios()({
    method: "get",
    url: bookBaseUrl(accountId),
    params,
  });

export const getBookById = (accountId, bookId) =>
  axios()({
    method: "get",
    url: bookDetailUrl(accountId, bookId),
  });

export const renameBook = (accountId, bookId, payload) =>
  axios()({
    method: "post",
    url: bookRenameUrl(accountId, bookId),
    data: payload,
  });

export const deleteBook = (accountId, bookId) =>
  axios()({
    method: "delete",
    url: bookDetailUrl(accountId, bookId),
  });

export const getBookChapters = (accountId, bookId, params = undefined) =>
  axios()({
    method: "get",
    url: bookChaptersUrl(accountId, bookId),
    params,
  });

export const createBookChapter = (accountId, bookId, payload) =>
  axios()({
    method: "post",
    url: bookCreateChapterUrl(accountId, bookId),
    data: payload,
  });
